import { useState } from 'react';
import Link from 'next/link';

import { Header, Footer } from '@components';

const Error = ({ statusCode }) => {
  const [headerClose, setHeaderClose] = useState(true);

  const headerValue = () => {
    setHeaderClose(false);
  };

  return (
    <div>
      <style jsx>
        {`
          main {
            height: 100vh;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
          }

          div.error-details,
          div.homepage-link-container {
            display: flex;
            justify-content: center;
            align-items: center;
          }

          div.error-details {
            flex-direction: row;
          }

          div.error-details > h1 {
            display: inline-block;
            border-right: 1px solid rgba(0, 0, 0, 0.3);
            margin: 0;
            margin-right: 20px;
            padding: 10px 23px 10px 0;
            font-size: 24px;
            font-weight: 500;
          }

          div.error-details > p {
            display: inline-block;
            text-align: left;
            margin: 0;
            padding: 10px 0;
          }

          div.homepage-link-container a {
            text-decoration: underline;
          }

          @media (max-width: 576px) {
            div.error-details {
              flex-direction: column;
            }
            div.error-details > h1 {
              border-right: 0;
              margin-right: 0;
              padding: 1rem 0;
            }
          }
        `}
      </style>

      <Header headerClose={headerClose} setHeaderValue={headerValue} />

      <main>
        <div className="error-details">
          {statusCode === 404 ? (
            <>
              <h1>404 - Page Not Found</h1>
              <p>This page could not be found</p>
            </>
          ) : (
            <>
              <h1>Oops, there was an error!</h1>
              <p>{statusCode ? `An error ${statusCode} occurred on server` : 'An error occurred on client'}</p>
            </>
          )}
        </div>
        <div className="homepage-link-container">
          <p>
            Return to{' '}
            <Link href="/" prefetch={false}>
              <a>homepage</a>
            </Link>
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

Error.getInitialProps = ({ res, err }) => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404;
  return { statusCode };
};

export default Error;
